import useDevice from 'hooks/useDevice';
import Landing from './Landing';
import MobileLanding from './MobileLanding';

export default function LandingPage() {
    const { isMobile } = useDevice();

    return isMobile ? <MobileLanding /> : <Landing />;
}
